import React, { useState } from 'react';
import { Button, Card } from 'react-bootstrap';

/**
 * One card per served catalog group, in the order given; `renderEntries(entries, group)` draws an open body.
 * An optional `group.title` node stands in for `label` in the header; the toggle still names the label.
 */
export default function CatalogGroups({ groups, renderEntries }) {
  const [opened, setOpened] = useState({});
  if (!Array.isArray(groups) || 0 === groups.length) return null;

  const toggle = (key) => setOpened((previous) => ({ ...previous, [key]: !previous[key] }));
  return (
    <div className="bh-catalog-groups">
      {groups.map((group) => {
        const open = !group.collapsed || !!opened[group.key];
        return (
          <Card key={group.key}>
            <Card.Header className="d-flex align-items-center">
              <span>{group.title || group.label}</span>
              {group.caption && <span className="card-header-meta ml-2">{group.caption}</span>}
              {(group.note || group.collapsed) && (
                <span className="card-header-meta ml-auto d-inline-flex align-items-center">
                  {group.note}
                  {group.collapsed && (
                    <Button variant="light" size="sm" className="btn-compact ml-2" aria-expanded={open}
                      aria-label={`${open ? 'Hide' : 'Show'} ${group.label}`} onClick={() => toggle(group.key)}>
                      {open ? 'Hide' : 'Show'}
                    </Button>
                  )}
                </span>
              )}
            </Card.Header>
            {open && <Card.Body>{renderEntries(group.entries || [], group)}</Card.Body>}
          </Card>
        );
      })}
    </div>
  );
}
